// @ts-nocheck
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AdminCreate201,
  AdminCreateBody,
  AdminGet200,
  AdminList200,
  AdminListParams,
  AdminUpdateBody,
  EchoesSync202,
  EchoesSyncBody,
  FilePutSignedUrl200,
  FilePutSignedUrlBody,
  MePermissionList200,
  OrganizationCreate201,
  OrganizationCreateBody,
  OrganizationIpRestrictionGet200,
  OrganizationIpRestrictionUpdateBody,
  OrganizationList200,
  OrganizationUpdateBody,
  OwnerGet200,
  OwnerGetParams,
  OwnerList200,
  OwnerListParams,
  OwnerUpdateAdminMemoBody,
  OwnerUpdateBody,
  PermissionList200,
  PlanCancelBody,
  PlanCreate201,
  PlanCreateBody,
  PlanExportRakutenParams,
  PlanGet200,
  PlanGetParams,
  PropertyCreate201,
  PropertyCreateBody,
  PropertyGet200,
  PropertyGetParams,
  PropertyList200,
  PropertyListParams,
  PropertyUpdateAdminMemoBody,
  PropertyUpdateBody,
  RoleCreate201,
  RoleCreateBody,
  RoleList200,
  RoleUpdateBody,
  RoomCreate201,
  RoomCreateBody,
  RoomGet200,
  RoomGetParams,
  RoomList200,
  RoomListParams,
  RoomUpdateAdminMemoBody,
  RoomUpdateBody,
  TenantApplicationGet200,
  TenantApplicationGetParams,
  TenantApplicationList200,
  TenantApplicationListParams,
  TenantCancelBody,
  TenantCreate201,
  TenantCreateBody,
  TenantGet200,
  TenantGetParams,
  TenantList200,
  TenantListParams,
  TenantUpdateAdminMemoBody,
  TenantUpdateBody,
  TicketAddProgress201,
  TicketAddProgressBody,
  TicketCommentUpdateBody,
  TicketCreate201,
  TicketCreateBody,
  TicketDelete200,
  TicketGet200,
  TicketGetParams,
  TicketList200,
  TicketListParams,
  TicketMessageCreate201,
  TicketMessageCreateBody,
  TicketMessageList200,
  TicketMessageListParams,
  TicketReadMessageBody,
  TicketUpdate200,
  TicketUpdateBody,
  TicketUpdateOcCommentBody
} from '../models';

import { customInstance } from '../../instance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary adminCreate
 */
export const getAdminCreateUrl = () => {


  

  return `/admins`
}

export const adminCreate = async (adminCreateBody: AdminCreateBody, options?: RequestInit): Promise<AdminCreate201> => {
  
  return customInstance<AdminCreate201>(getAdminCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminCreateBody,)
  }
);}




export const getAdminCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreate>>, TError,{data: AdminCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminCreate>>, TError,{data: AdminCreateBody}, TContext> => {

const mutationKey = ['adminCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCreate>>, {data: AdminCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  adminCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminCreate>>>
    export type AdminCreateMutationBody = AdminCreateBody
    export type AdminCreateMutationError = unknown

    /**
 * @summary adminCreate
 */
export const useAdminCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCreate>>, TError,{data: AdminCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminCreate>>,
        TError,
        {data: AdminCreateBody},
        TContext
      > => {

      const mutationOptions = getAdminCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary adminList
 */
export const getAdminListUrl = (params?: AdminListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admins?${stringifiedParams}` : `/admins`
}

export const adminList = async (params?: AdminListParams, options?: RequestInit): Promise<AdminList200> => {
  
  return customInstance<AdminList200>(getAdminListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getAdminListQueryKey = (params?: AdminListParams,) => {
    return [`/admins`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminListQueryOptions = <TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(params?: AdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminList>>> = ({ signal }) => adminList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListQueryResult = NonNullable<Awaited<ReturnType<typeof adminList>>>
export type AdminListQueryError = unknown


export function useAdminList<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params: undefined |  AdminListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminList>>,
          TError,
          Awaited<ReturnType<typeof adminList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminList<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminList>>,
          TError,
          Awaited<ReturnType<typeof adminList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminList<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary adminList
 */

export function useAdminList<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(params?: AdminListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminList>>> = ({ signal }) => adminList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminList>>>
export type AdminListSuspenseQueryError = unknown


export function useAdminListSuspense<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params: undefined |  AdminListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListSuspense<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListSuspense<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary adminList
 */

export function useAdminListSuspense<TData = Awaited<ReturnType<typeof adminList>>, TError = unknown>(
 params?: AdminListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary adminGet
 */
export const getAdminGetUrl = (id: string,) => {


  

  return `/admins/${id}`
}

export const adminGet = async (id: string, options?: RequestInit): Promise<AdminGet200> => {
  
  return customInstance<AdminGet200>(getAdminGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getAdminGetQueryKey = (id?: string,) => {
    return [`/admins/${id}`] as const;
    }

    
export const getAdminGetQueryOptions = <TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGet>>> = ({ signal }) => adminGet(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminGet>>>
export type AdminGetQueryError = unknown


export function useAdminGet<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGet>>,
          TError,
          Awaited<ReturnType<typeof adminGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGet<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGet>>,
          TError,
          Awaited<ReturnType<typeof adminGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGet<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary adminGet
 */

export function useAdminGet<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGet>>> = ({ signal }) => adminGet(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminGet>>>
export type AdminGetSuspenseQueryError = unknown


export function useAdminGetSuspense<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetSuspense<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetSuspense<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary adminGet
 */

export function useAdminGetSuspense<TData = Awaited<ReturnType<typeof adminGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary adminUpdate
 */
export const getAdminUpdateUrl = (id: string,) => {


  

  return `/admins/${id}`
}

export const adminUpdate = async (id: string,
    adminUpdateBody: AdminUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getAdminUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      adminUpdateBody,)
  }
);}




export const getAdminUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdate>>, TError,{id: string;data: AdminUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUpdate>>, TError,{id: string;data: AdminUpdateBody}, TContext> => {

const mutationKey = ['adminUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUpdate>>, {id: string;data: AdminUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminUpdate>>>
    export type AdminUpdateMutationBody = AdminUpdateBody
    export type AdminUpdateMutationError = unknown

    /**
 * @summary adminUpdate
 */
export const useAdminUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUpdate>>, TError,{id: string;data: AdminUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUpdate>>,
        TError,
        {id: string;data: AdminUpdateBody},
        TContext
      > => {

      const mutationOptions = getAdminUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary adminDelete
 */
export const getAdminDeleteUrl = (id: string,) => {


  

  return `/admins/${id}`
}

export const adminDelete = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getAdminDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAdminDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminDelete>>>
    
    export type AdminDeleteMutationError = unknown

    /**
 * @summary adminDelete
 */
export const useAdminDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary echoesSync
 */
export const getEchoesSyncUrl = () => {


  

  return `/api/echoes/sync`
}

export const echoesSync = async (echoesSyncBody: EchoesSyncBody, options?: RequestInit): Promise<EchoesSync202> => {
  
  return customInstance<EchoesSync202>(getEchoesSyncUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      echoesSyncBody,)
  }
);}




export const getEchoesSyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof echoesSync>>, TError,{data: EchoesSyncBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof echoesSync>>, TError,{data: EchoesSyncBody}, TContext> => {

const mutationKey = ['echoesSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof echoesSync>>, {data: EchoesSyncBody}> = (props) => {
          const {data} = props ?? {};

          return  echoesSync(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EchoesSyncMutationResult = NonNullable<Awaited<ReturnType<typeof echoesSync>>>
    export type EchoesSyncMutationBody = EchoesSyncBody
    export type EchoesSyncMutationError = unknown

    /**
 * @summary echoesSync
 */
export const useEchoesSync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof echoesSync>>, TError,{data: EchoesSyncBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof echoesSync>>,
        TError,
        {data: EchoesSyncBody},
        TContext
      > => {

      const mutationOptions = getEchoesSyncMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ファイルアップロード用署名付きURL取得
 */
export const getFilePutSignedUrlUrl = () => {


  

  return `/files/put-signed-url`
}

export const filePutSignedUrl = async (filePutSignedUrlBody: FilePutSignedUrlBody, options?: RequestInit): Promise<FilePutSignedUrl200> => {
  
  return customInstance<FilePutSignedUrl200>(getFilePutSignedUrlUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      filePutSignedUrlBody,)
  }
);}




export const getFilePutSignedUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext> => {

const mutationKey = ['filePutSignedUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof filePutSignedUrl>>, {data: FilePutSignedUrlBody}> = (props) => {
          const {data} = props ?? {};

          return  filePutSignedUrl(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FilePutSignedUrlMutationResult = NonNullable<Awaited<ReturnType<typeof filePutSignedUrl>>>
    export type FilePutSignedUrlMutationBody = FilePutSignedUrlBody
    export type FilePutSignedUrlMutationError = unknown

    /**
 * @summary ファイルアップロード用署名付きURL取得
 */
export const useFilePutSignedUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof filePutSignedUrl>>, TError,{data: FilePutSignedUrlBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof filePutSignedUrl>>,
        TError,
        {data: FilePutSignedUrlBody},
        TContext
      > => {

      const mutationOptions = getFilePutSignedUrlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary mePermissionList
 */
export const getMePermissionListUrl = () => {


  

  return `/me/permissions`
}

export const mePermissionList = async ( options?: RequestInit): Promise<MePermissionList200> => {
  
  return customInstance<MePermissionList200>(getMePermissionListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getMePermissionListQueryKey = () => {
    return [`/me/permissions`] as const;
    }

    
export const getMePermissionListQueryOptions = <TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMePermissionListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof mePermissionList>>> = ({ signal }) => mePermissionList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MePermissionListQueryResult = NonNullable<Awaited<ReturnType<typeof mePermissionList>>>
export type MePermissionListQueryError = unknown


export function useMePermissionList<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mePermissionList>>,
          TError,
          Awaited<ReturnType<typeof mePermissionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePermissionList<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mePermissionList>>,
          TError,
          Awaited<ReturnType<typeof mePermissionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePermissionList<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary mePermissionList
 */

export function useMePermissionList<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMePermissionListQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMePermissionListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMePermissionListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof mePermissionList>>> = ({ signal }) => mePermissionList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MePermissionListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof mePermissionList>>>
export type MePermissionListSuspenseQueryError = unknown


export function useMePermissionListSuspense<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePermissionListSuspense<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMePermissionListSuspense<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary mePermissionList
 */

export function useMePermissionListSuspense<TData = Awaited<ReturnType<typeof mePermissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof mePermissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMePermissionListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary organizationList
 */
export const getOrganizationListUrl = () => {


  

  return `/organizations`
}

export const organizationList = async ( options?: RequestInit): Promise<OrganizationList200> => {
  
  return customInstance<OrganizationList200>(getOrganizationListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOrganizationListQueryKey = () => {
    return [`/organizations`] as const;
    }

    
export const getOrganizationListQueryOptions = <TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationList>>> = ({ signal }) => organizationList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationListQueryResult = NonNullable<Awaited<ReturnType<typeof organizationList>>>
export type OrganizationListQueryError = unknown


export function useOrganizationList<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationList>>,
          TError,
          Awaited<ReturnType<typeof organizationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationList<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationList>>,
          TError,
          Awaited<ReturnType<typeof organizationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationList<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationList
 */

export function useOrganizationList<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationListQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationList>>> = ({ signal }) => organizationList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationList>>>
export type OrganizationListSuspenseQueryError = unknown


export function useOrganizationListSuspense<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListSuspense<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationListSuspense<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationList
 */

export function useOrganizationListSuspense<TData = Awaited<ReturnType<typeof organizationList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary organizationCreate
 */
export const getOrganizationCreateUrl = () => {


  

  return `/organizations`
}

export const organizationCreate = async (organizationCreateBody: OrganizationCreateBody, options?: RequestInit): Promise<OrganizationCreate201> => {
  
  return customInstance<OrganizationCreate201>(getOrganizationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      organizationCreateBody,)
  }
);}




export const getOrganizationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: OrganizationCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: OrganizationCreateBody}, TContext> => {

const mutationKey = ['organizationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationCreate>>, {data: OrganizationCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  organizationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationCreate>>>
    export type OrganizationCreateMutationBody = OrganizationCreateBody
    export type OrganizationCreateMutationError = unknown

    /**
 * @summary organizationCreate
 */
export const useOrganizationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: OrganizationCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationCreate>>,
        TError,
        {data: OrganizationCreateBody},
        TContext
      > => {

      const mutationOptions = getOrganizationCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary organizationUpdate
 */
export const getOrganizationUpdateUrl = (id: string,) => {


  

  return `/organizations/${id}`
}

export const organizationUpdate = async (id: string,
    organizationUpdateBody: OrganizationUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOrganizationUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      organizationUpdateBody,)
  }
);}




export const getOrganizationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: OrganizationUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: OrganizationUpdateBody}, TContext> => {

const mutationKey = ['organizationUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationUpdate>>, {id: string;data: OrganizationUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationUpdate>>>
    export type OrganizationUpdateMutationBody = OrganizationUpdateBody
    export type OrganizationUpdateMutationError = unknown

    /**
 * @summary organizationUpdate
 */
export const useOrganizationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: OrganizationUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationUpdate>>,
        TError,
        {id: string;data: OrganizationUpdateBody},
        TContext
      > => {

      const mutationOptions = getOrganizationUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary organizationIpRestrictionGet
 */
export const getOrganizationIpRestrictionGetUrl = (id: string,) => {


  

  return `/organizations/${id}/ip_restriction`
}

export const organizationIpRestrictionGet = async (id: string, options?: RequestInit): Promise<OrganizationIpRestrictionGet200> => {
  
  return customInstance<OrganizationIpRestrictionGet200>(getOrganizationIpRestrictionGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOrganizationIpRestrictionGetQueryKey = (id?: string,) => {
    return [`/organizations/${id}/ip_restriction`] as const;
    }

    
export const getOrganizationIpRestrictionGetQueryOptions = <TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationIpRestrictionGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationIpRestrictionGet>>> = ({ signal }) => organizationIpRestrictionGet(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationIpRestrictionGetQueryResult = NonNullable<Awaited<ReturnType<typeof organizationIpRestrictionGet>>>
export type OrganizationIpRestrictionGetQueryError = unknown


export function useOrganizationIpRestrictionGet<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationIpRestrictionGet>>,
          TError,
          Awaited<ReturnType<typeof organizationIpRestrictionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationIpRestrictionGet<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationIpRestrictionGet>>,
          TError,
          Awaited<ReturnType<typeof organizationIpRestrictionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationIpRestrictionGet<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationIpRestrictionGet
 */

export function useOrganizationIpRestrictionGet<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationIpRestrictionGetQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationIpRestrictionGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationIpRestrictionGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationIpRestrictionGet>>> = ({ signal }) => organizationIpRestrictionGet(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationIpRestrictionGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationIpRestrictionGet>>>
export type OrganizationIpRestrictionGetSuspenseQueryError = unknown


export function useOrganizationIpRestrictionGetSuspense<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationIpRestrictionGetSuspense<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationIpRestrictionGetSuspense<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationIpRestrictionGet
 */

export function useOrganizationIpRestrictionGetSuspense<TData = Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationIpRestrictionGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationIpRestrictionGetSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary organizationIpRestrictionUpdate
 */
export const getOrganizationIpRestrictionUpdateUrl = (id: string,) => {


  

  return `/organizations/${id}/ip_restriction`
}

export const organizationIpRestrictionUpdate = async (id: string,
    organizationIpRestrictionUpdateBody: OrganizationIpRestrictionUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOrganizationIpRestrictionUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      organizationIpRestrictionUpdateBody,)
  }
);}




export const getOrganizationIpRestrictionUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>, TError,{id: string;data: OrganizationIpRestrictionUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>, TError,{id: string;data: OrganizationIpRestrictionUpdateBody}, TContext> => {

const mutationKey = ['organizationIpRestrictionUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>, {id: string;data: OrganizationIpRestrictionUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationIpRestrictionUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationIpRestrictionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>>
    export type OrganizationIpRestrictionUpdateMutationBody = OrganizationIpRestrictionUpdateBody
    export type OrganizationIpRestrictionUpdateMutationError = unknown

    /**
 * @summary organizationIpRestrictionUpdate
 */
export const useOrganizationIpRestrictionUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>, TError,{id: string;data: OrganizationIpRestrictionUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationIpRestrictionUpdate>>,
        TError,
        {id: string;data: OrganizationIpRestrictionUpdateBody},
        TContext
      > => {

      const mutationOptions = getOrganizationIpRestrictionUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerGet
 */
export const getOwnerGetUrl = (id: string,
    params?: OwnerGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/owners/${id}?${stringifiedParams}` : `/owners/${id}`
}

export const ownerGet = async (id: string,
    params?: OwnerGetParams, options?: RequestInit): Promise<OwnerGet200> => {
  
  return customInstance<OwnerGet200>(getOwnerGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOwnerGetQueryKey = (id?: string,
    params?: OwnerGetParams,) => {
    return [`/owners/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getOwnerGetQueryOptions = <TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerGet>>> = ({ signal }) => ownerGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerGetQueryResult = NonNullable<Awaited<ReturnType<typeof ownerGet>>>
export type OwnerGetQueryError = unknown


export function useOwnerGet<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params: undefined |  OwnerGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerGet>>,
          TError,
          Awaited<ReturnType<typeof ownerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerGet<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerGet>>,
          TError,
          Awaited<ReturnType<typeof ownerGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerGet<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerGet
 */

export function useOwnerGet<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOwnerGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerGet>>> = ({ signal }) => ownerGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ownerGet>>>
export type OwnerGetSuspenseQueryError = unknown


export function useOwnerGetSuspense<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params: undefined |  OwnerGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerGetSuspense<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerGetSuspense<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerGet
 */

export function useOwnerGetSuspense<TData = Awaited<ReturnType<typeof ownerGet>>, TError = unknown>(
 id: string,
    params?: OwnerGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ownerUpdate
 */
export const getOwnerUpdateUrl = (id: string,) => {


  

  return `/owners/${id}`
}

export const ownerUpdate = async (id: string,
    ownerUpdateBody: OwnerUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOwnerUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ownerUpdateBody,)
  }
);}




export const getOwnerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerUpdate>>, TError,{id: string;data: OwnerUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ownerUpdate>>, TError,{id: string;data: OwnerUpdateBody}, TContext> => {

const mutationKey = ['ownerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownerUpdate>>, {id: string;data: OwnerUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ownerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OwnerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ownerUpdate>>>
    export type OwnerUpdateMutationBody = OwnerUpdateBody
    export type OwnerUpdateMutationError = unknown

    /**
 * @summary ownerUpdate
 */
export const useOwnerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerUpdate>>, TError,{id: string;data: OwnerUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ownerUpdate>>,
        TError,
        {id: string;data: OwnerUpdateBody},
        TContext
      > => {

      const mutationOptions = getOwnerUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ownerList
 */
export const getOwnerListUrl = (params?: OwnerListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/owners?${stringifiedParams}` : `/owners`
}

export const ownerList = async (params?: OwnerListParams, options?: RequestInit): Promise<OwnerList200> => {
  
  return customInstance<OwnerList200>(getOwnerListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getOwnerListQueryKey = (params?: OwnerListParams,) => {
    return [`/owners`, ...(params ? [params]: [])] as const;
    }

    
export const getOwnerListQueryOptions = <TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(params?: OwnerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerList>>> = ({ signal }) => ownerList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerListQueryResult = NonNullable<Awaited<ReturnType<typeof ownerList>>>
export type OwnerListQueryError = unknown


export function useOwnerList<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params: undefined |  OwnerListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerList>>,
          TError,
          Awaited<ReturnType<typeof ownerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerList<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ownerList>>,
          TError,
          Awaited<ReturnType<typeof ownerList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerList<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerList
 */

export function useOwnerList<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOwnerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(params?: OwnerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOwnerListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ownerList>>> = ({ signal }) => ownerList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OwnerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ownerList>>>
export type OwnerListSuspenseQueryError = unknown


export function useOwnerListSuspense<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params: undefined |  OwnerListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerListSuspense<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOwnerListSuspense<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ownerList
 */

export function useOwnerListSuspense<TData = Awaited<ReturnType<typeof ownerList>>, TError = unknown>(
 params?: OwnerListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ownerList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOwnerListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ownerUpdateAdminMemo
 */
export const getOwnerUpdateAdminMemoUrl = (id: string,) => {


  

  return `/owners/${id}/admin_memo`
}

export const ownerUpdateAdminMemo = async (id: string,
    ownerUpdateAdminMemoBody: OwnerUpdateAdminMemoBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getOwnerUpdateAdminMemoUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ownerUpdateAdminMemoBody,)
  }
);}




export const getOwnerUpdateAdminMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerUpdateAdminMemo>>, TError,{id: string;data: OwnerUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ownerUpdateAdminMemo>>, TError,{id: string;data: OwnerUpdateAdminMemoBody}, TContext> => {

const mutationKey = ['ownerUpdateAdminMemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ownerUpdateAdminMemo>>, {id: string;data: OwnerUpdateAdminMemoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ownerUpdateAdminMemo(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OwnerUpdateAdminMemoMutationResult = NonNullable<Awaited<ReturnType<typeof ownerUpdateAdminMemo>>>
    export type OwnerUpdateAdminMemoMutationBody = OwnerUpdateAdminMemoBody
    export type OwnerUpdateAdminMemoMutationError = unknown

    /**
 * @summary ownerUpdateAdminMemo
 */
export const useOwnerUpdateAdminMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ownerUpdateAdminMemo>>, TError,{id: string;data: OwnerUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ownerUpdateAdminMemo>>,
        TError,
        {id: string;data: OwnerUpdateAdminMemoBody},
        TContext
      > => {

      const mutationOptions = getOwnerUpdateAdminMemoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary permissionList
 */
export const getPermissionListUrl = () => {


  

  return `/permissions`
}

export const permissionList = async ( options?: RequestInit): Promise<PermissionList200> => {
  
  return customInstance<PermissionList200>(getPermissionListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPermissionListQueryKey = () => {
    return [`/permissions`] as const;
    }

    
export const getPermissionListQueryOptions = <TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionList>>> = ({ signal }) => permissionList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionListQueryResult = NonNullable<Awaited<ReturnType<typeof permissionList>>>
export type PermissionListQueryError = unknown


export function usePermissionList<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionList>>,
          TError,
          Awaited<ReturnType<typeof permissionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionList<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionList>>,
          TError,
          Awaited<ReturnType<typeof permissionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionList<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary permissionList
 */

export function usePermissionList<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionListQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPermissionListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionList>>> = ({ signal }) => permissionList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof permissionList>>>
export type PermissionListSuspenseQueryError = unknown


export function usePermissionListSuspense<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionListSuspense<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionListSuspense<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary permissionList
 */

export function usePermissionListSuspense<TData = Awaited<ReturnType<typeof permissionList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary planExportRakuten
 */
export const getPlanExportRakutenUrl = (params?: PlanExportRakutenParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plans/exportRakuten?${stringifiedParams}` : `/plans/exportRakuten`
}

export const planExportRakuten = async (params?: PlanExportRakutenParams, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getPlanExportRakutenUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPlanExportRakutenQueryKey = (params?: PlanExportRakutenParams,) => {
    return [`/plans/exportRakuten`, ...(params ? [params]: [])] as const;
    }

    
export const getPlanExportRakutenQueryOptions = <TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(params?: PlanExportRakutenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanExportRakutenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planExportRakuten>>> = ({ signal }) => planExportRakuten(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanExportRakutenQueryResult = NonNullable<Awaited<ReturnType<typeof planExportRakuten>>>
export type PlanExportRakutenQueryError = unknown


export function usePlanExportRakuten<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params: undefined |  PlanExportRakutenParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof planExportRakuten>>,
          TError,
          Awaited<ReturnType<typeof planExportRakuten>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanExportRakuten<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof planExportRakuten>>,
          TError,
          Awaited<ReturnType<typeof planExportRakuten>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanExportRakuten<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planExportRakuten
 */

export function usePlanExportRakuten<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanExportRakutenQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPlanExportRakutenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(params?: PlanExportRakutenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanExportRakutenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planExportRakuten>>> = ({ signal }) => planExportRakuten(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanExportRakutenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof planExportRakuten>>>
export type PlanExportRakutenSuspenseQueryError = unknown


export function usePlanExportRakutenSuspense<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params: undefined |  PlanExportRakutenParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanExportRakutenSuspense<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanExportRakutenSuspense<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planExportRakuten
 */

export function usePlanExportRakutenSuspense<TData = Awaited<ReturnType<typeof planExportRakuten>>, TError = unknown>(
 params?: PlanExportRakutenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planExportRakuten>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanExportRakutenSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary planGet
 */
export const getPlanGetUrl = (id: string,
    params?: PlanGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plans/${id}?${stringifiedParams}` : `/plans/${id}`
}

export const planGet = async (id: string,
    params?: PlanGetParams, options?: RequestInit): Promise<PlanGet200> => {
  
  return customInstance<PlanGet200>(getPlanGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPlanGetQueryKey = (id?: string,
    params?: PlanGetParams,) => {
    return [`/plans/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getPlanGetQueryOptions = <TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planGet>>> = ({ signal }) => planGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanGetQueryResult = NonNullable<Awaited<ReturnType<typeof planGet>>>
export type PlanGetQueryError = unknown


export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params: undefined |  PlanGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof planGet>>,
          TError,
          Awaited<ReturnType<typeof planGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof planGet>>,
          TError,
          Awaited<ReturnType<typeof planGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planGet
 */

export function usePlanGet<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPlanGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlanGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof planGet>>> = ({ signal }) => planGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlanGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof planGet>>>
export type PlanGetSuspenseQueryError = unknown


export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params: undefined |  PlanGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary planGet
 */

export function usePlanGetSuspense<TData = Awaited<ReturnType<typeof planGet>>, TError = unknown>(
 id: string,
    params?: PlanGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof planGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlanGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary planDelete
 */
export const getPlanDeleteUrl = (id: string,) => {


  

  return `/plans/${id}`
}

export const planDelete = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getPlanDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['planDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  planDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof planDelete>>>
    
    export type PlanDeleteMutationError = unknown

    /**
 * @summary planDelete
 */
export const usePlanDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPlanDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planCreate
 */
export const getPlanCreateUrl = () => {


  

  return `/plans`
}

export const planCreate = async (planCreateBody: PlanCreateBody, options?: RequestInit): Promise<PlanCreate201> => {
  
  return customInstance<PlanCreate201>(getPlanCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planCreateBody,)
  }
);}




export const getPlanCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext> => {

const mutationKey = ['planCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planCreate>>, {data: PlanCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  planCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof planCreate>>>
    export type PlanCreateMutationBody = PlanCreateBody
    export type PlanCreateMutationError = unknown

    /**
 * @summary planCreate
 */
export const usePlanCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCreate>>, TError,{data: PlanCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planCreate>>,
        TError,
        {data: PlanCreateBody},
        TContext
      > => {

      const mutationOptions = getPlanCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planCancel
 */
export const getPlanCancelUrl = (id: string,) => {


  

  return `/plans/${id}/cancel`
}

export const planCancel = async (id: string,
    planCancelBody: PlanCancelBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanCancelUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      planCancelBody,)
  }
);}




export const getPlanCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{id: string;data: PlanCancelBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{id: string;data: PlanCancelBody}, TContext> => {

const mutationKey = ['planCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planCancel>>, {id: string;data: PlanCancelBody}> = (props) => {
          const {id,data} = props ?? {};

          return  planCancel(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanCancelMutationResult = NonNullable<Awaited<ReturnType<typeof planCancel>>>
    export type PlanCancelMutationBody = PlanCancelBody
    export type PlanCancelMutationError = unknown

    /**
 * @summary planCancel
 */
export const usePlanCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planCancel>>, TError,{id: string;data: PlanCancelBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planCancel>>,
        TError,
        {id: string;data: PlanCancelBody},
        TContext
      > => {

      const mutationOptions = getPlanCancelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary planRevival
 */
export const getPlanRevivalUrl = (id: string,) => {


  

  return `/plans/${id}/revival`
}

export const planRevival = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPlanRevivalUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getPlanRevivalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id: string}, TContext> => {

const mutationKey = ['planRevival'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof planRevival>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  planRevival(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlanRevivalMutationResult = NonNullable<Awaited<ReturnType<typeof planRevival>>>
    
    export type PlanRevivalMutationError = unknown

    /**
 * @summary planRevival
 */
export const usePlanRevival = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof planRevival>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof planRevival>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPlanRevivalMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyGet
 */
export const getPropertyGetUrl = (id: string,
    params?: PropertyGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/properties/${id}?${stringifiedParams}` : `/properties/${id}`
}

export const propertyGet = async (id: string,
    params?: PropertyGetParams, options?: RequestInit): Promise<PropertyGet200> => {
  
  return customInstance<PropertyGet200>(getPropertyGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPropertyGetQueryKey = (id?: string,
    params?: PropertyGetParams,) => {
    return [`/properties/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getPropertyGetQueryOptions = <TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyGet>>> = ({ signal }) => propertyGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyGetQueryResult = NonNullable<Awaited<ReturnType<typeof propertyGet>>>
export type PropertyGetQueryError = unknown


export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params: undefined |  PropertyGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyGet>>,
          TError,
          Awaited<ReturnType<typeof propertyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyGet>>,
          TError,
          Awaited<ReturnType<typeof propertyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyGet
 */

export function usePropertyGet<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPropertyGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyGet>>> = ({ signal }) => propertyGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof propertyGet>>>
export type PropertyGetSuspenseQueryError = unknown


export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params: undefined |  PropertyGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyGet
 */

export function usePropertyGetSuspense<TData = Awaited<ReturnType<typeof propertyGet>>, TError = unknown>(
 id: string,
    params?: PropertyGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary propertyUpdate
 */
export const getPropertyUpdateUrl = (id: string,) => {


  

  return `/properties/${id}`
}

export const propertyUpdate = async (id: string,
    propertyUpdateBody: PropertyUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPropertyUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      propertyUpdateBody,)
  }
);}




export const getPropertyUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{id: string;data: PropertyUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{id: string;data: PropertyUpdateBody}, TContext> => {

const mutationKey = ['propertyUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyUpdate>>, {id: string;data: PropertyUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  propertyUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof propertyUpdate>>>
    export type PropertyUpdateMutationBody = PropertyUpdateBody
    export type PropertyUpdateMutationError = unknown

    /**
 * @summary propertyUpdate
 */
export const usePropertyUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdate>>, TError,{id: string;data: PropertyUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyUpdate>>,
        TError,
        {id: string;data: PropertyUpdateBody},
        TContext
      > => {

      const mutationOptions = getPropertyUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyList
 */
export const getPropertyListUrl = (params?: PropertyListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/properties?${stringifiedParams}` : `/properties`
}

export const propertyList = async (params?: PropertyListParams, options?: RequestInit): Promise<PropertyList200> => {
  
  return customInstance<PropertyList200>(getPropertyListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getPropertyListQueryKey = (params?: PropertyListParams,) => {
    return [`/properties`, ...(params ? [params]: [])] as const;
    }

    
export const getPropertyListQueryOptions = <TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyList>>> = ({ signal }) => propertyList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyListQueryResult = NonNullable<Awaited<ReturnType<typeof propertyList>>>
export type PropertyListQueryError = unknown


export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params: undefined |  PropertyListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyList>>,
          TError,
          Awaited<ReturnType<typeof propertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof propertyList>>,
          TError,
          Awaited<ReturnType<typeof propertyList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyList
 */

export function usePropertyList<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPropertyListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPropertyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof propertyList>>> = ({ signal }) => propertyList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PropertyListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof propertyList>>>
export type PropertyListSuspenseQueryError = unknown


export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params: undefined |  PropertyListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary propertyList
 */

export function usePropertyListSuspense<TData = Awaited<ReturnType<typeof propertyList>>, TError = unknown>(
 params?: PropertyListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof propertyList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPropertyListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary propertyCreate
 */
export const getPropertyCreateUrl = () => {


  

  return `/properties`
}

export const propertyCreate = async (propertyCreateBody: PropertyCreateBody, options?: RequestInit): Promise<PropertyCreate201> => {
  
  return customInstance<PropertyCreate201>(getPropertyCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      propertyCreateBody,)
  }
);}




export const getPropertyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext> => {

const mutationKey = ['propertyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyCreate>>, {data: PropertyCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  propertyCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof propertyCreate>>>
    export type PropertyCreateMutationBody = PropertyCreateBody
    export type PropertyCreateMutationError = unknown

    /**
 * @summary propertyCreate
 */
export const usePropertyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyCreate>>, TError,{data: PropertyCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyCreate>>,
        TError,
        {data: PropertyCreateBody},
        TContext
      > => {

      const mutationOptions = getPropertyCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary propertyUpdateAdminMemo
 */
export const getPropertyUpdateAdminMemoUrl = (id: string,) => {


  

  return `/properties/${id}/admin_memo`
}

export const propertyUpdateAdminMemo = async (id: string,
    propertyUpdateAdminMemoBody: PropertyUpdateAdminMemoBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getPropertyUpdateAdminMemoUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      propertyUpdateAdminMemoBody,)
  }
);}




export const getPropertyUpdateAdminMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdateAdminMemo>>, TError,{id: string;data: PropertyUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof propertyUpdateAdminMemo>>, TError,{id: string;data: PropertyUpdateAdminMemoBody}, TContext> => {

const mutationKey = ['propertyUpdateAdminMemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof propertyUpdateAdminMemo>>, {id: string;data: PropertyUpdateAdminMemoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  propertyUpdateAdminMemo(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PropertyUpdateAdminMemoMutationResult = NonNullable<Awaited<ReturnType<typeof propertyUpdateAdminMemo>>>
    export type PropertyUpdateAdminMemoMutationBody = PropertyUpdateAdminMemoBody
    export type PropertyUpdateAdminMemoMutationError = unknown

    /**
 * @summary propertyUpdateAdminMemo
 */
export const usePropertyUpdateAdminMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof propertyUpdateAdminMemo>>, TError,{id: string;data: PropertyUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof propertyUpdateAdminMemo>>,
        TError,
        {id: string;data: PropertyUpdateAdminMemoBody},
        TContext
      > => {

      const mutationOptions = getPropertyUpdateAdminMemoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roleList
 */
export const getRoleListUrl = () => {


  

  return `/roles`
}

export const roleList = async ( options?: RequestInit): Promise<RoleList200> => {
  
  return customInstance<RoleList200>(getRoleListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getRoleListQueryKey = () => {
    return [`/roles`] as const;
    }

    
export const getRoleListQueryOptions = <TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoleListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roleList>>> = ({ signal }) => roleList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoleListQueryResult = NonNullable<Awaited<ReturnType<typeof roleList>>>
export type RoleListQueryError = unknown


export function useRoleList<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleList>>,
          TError,
          Awaited<ReturnType<typeof roleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoleList<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roleList>>,
          TError,
          Awaited<ReturnType<typeof roleList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoleList<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roleList
 */

export function useRoleList<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoleListQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRoleListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoleListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roleList>>> = ({ signal }) => roleList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoleListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roleList>>>
export type RoleListSuspenseQueryError = unknown


export function useRoleListSuspense<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoleListSuspense<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoleListSuspense<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roleList
 */

export function useRoleListSuspense<TData = Awaited<ReturnType<typeof roleList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roleList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoleListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary roleCreate
 */
export const getRoleCreateUrl = () => {


  

  return `/roles`
}

export const roleCreate = async (roleCreateBody: RoleCreateBody, options?: RequestInit): Promise<RoleCreate201> => {
  
  return customInstance<RoleCreate201>(getRoleCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleCreateBody,)
  }
);}




export const getRoleCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleCreate>>, TError,{data: RoleCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roleCreate>>, TError,{data: RoleCreateBody}, TContext> => {

const mutationKey = ['roleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roleCreate>>, {data: RoleCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  roleCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof roleCreate>>>
    export type RoleCreateMutationBody = RoleCreateBody
    export type RoleCreateMutationError = unknown

    /**
 * @summary roleCreate
 */
export const useRoleCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleCreate>>, TError,{data: RoleCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roleCreate>>,
        TError,
        {data: RoleCreateBody},
        TContext
      > => {

      const mutationOptions = getRoleCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roleUpdate
 */
export const getRoleUpdateUrl = (organizationId: string,
    role: string,) => {


  

  return `/roles/${organizationId}/${role}`
}

export const roleUpdate = async (organizationId: string,
    role: string,
    roleUpdateBody: RoleUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoleUpdateUrl(organizationId,role),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roleUpdateBody,)
  }
);}




export const getRoleUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleUpdate>>, TError,{organizationId: string;role: string;data: RoleUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roleUpdate>>, TError,{organizationId: string;role: string;data: RoleUpdateBody}, TContext> => {

const mutationKey = ['roleUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roleUpdate>>, {organizationId: string;role: string;data: RoleUpdateBody}> = (props) => {
          const {organizationId,role,data} = props ?? {};

          return  roleUpdate(organizationId,role,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoleUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof roleUpdate>>>
    export type RoleUpdateMutationBody = RoleUpdateBody
    export type RoleUpdateMutationError = unknown

    /**
 * @summary roleUpdate
 */
export const useRoleUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleUpdate>>, TError,{organizationId: string;role: string;data: RoleUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roleUpdate>>,
        TError,
        {organizationId: string;role: string;data: RoleUpdateBody},
        TContext
      > => {

      const mutationOptions = getRoleUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roleDelete
 */
export const getRoleDeleteUrl = (organizationId: string,
    role: string,) => {


  

  return `/roles/${organizationId}/${role}`
}

export const roleDelete = async (organizationId: string,
    role: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoleDeleteUrl(organizationId,role),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getRoleDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleDelete>>, TError,{organizationId: string;role: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roleDelete>>, TError,{organizationId: string;role: string}, TContext> => {

const mutationKey = ['roleDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roleDelete>>, {organizationId: string;role: string}> = (props) => {
          const {organizationId,role} = props ?? {};

          return  roleDelete(organizationId,role,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoleDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof roleDelete>>>
    
    export type RoleDeleteMutationError = unknown

    /**
 * @summary roleDelete
 */
export const useRoleDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roleDelete>>, TError,{organizationId: string;role: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roleDelete>>,
        TError,
        {organizationId: string;role: string},
        TContext
      > => {

      const mutationOptions = getRoleDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomGet
 */
export const getRoomGetUrl = (id: string,
    params?: RoomGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rooms/${id}?${stringifiedParams}` : `/rooms/${id}`
}

export const roomGet = async (id: string,
    params?: RoomGetParams, options?: RequestInit): Promise<RoomGet200> => {
  
  return customInstance<RoomGet200>(getRoomGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getRoomGetQueryKey = (id?: string,
    params?: RoomGetParams,) => {
    return [`/rooms/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getRoomGetQueryOptions = <TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomGet>>> = ({ signal }) => roomGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomGetQueryResult = NonNullable<Awaited<ReturnType<typeof roomGet>>>
export type RoomGetQueryError = unknown


export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params: undefined |  RoomGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomGet>>,
          TError,
          Awaited<ReturnType<typeof roomGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomGet>>,
          TError,
          Awaited<ReturnType<typeof roomGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomGet
 */

export function useRoomGet<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRoomGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomGet>>> = ({ signal }) => roomGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roomGet>>>
export type RoomGetSuspenseQueryError = unknown


export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params: undefined |  RoomGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomGet
 */

export function useRoomGetSuspense<TData = Awaited<ReturnType<typeof roomGet>>, TError = unknown>(
 id: string,
    params?: RoomGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary roomUpdate
 */
export const getRoomUpdateUrl = (id: string,) => {


  

  return `/rooms/${id}`
}

export const roomUpdate = async (id: string,
    roomUpdateBody: RoomUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoomUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roomUpdateBody,)
  }
);}




export const getRoomUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{id: string;data: RoomUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{id: string;data: RoomUpdateBody}, TContext> => {

const mutationKey = ['roomUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomUpdate>>, {id: string;data: RoomUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  roomUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof roomUpdate>>>
    export type RoomUpdateMutationBody = RoomUpdateBody
    export type RoomUpdateMutationError = unknown

    /**
 * @summary roomUpdate
 */
export const useRoomUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdate>>, TError,{id: string;data: RoomUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomUpdate>>,
        TError,
        {id: string;data: RoomUpdateBody},
        TContext
      > => {

      const mutationOptions = getRoomUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomDelete
 */
export const getRoomDeleteUrl = (id: string,) => {


  

  return `/rooms/${id}`
}

export const roomDelete = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoomDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getRoomDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['roomDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  roomDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof roomDelete>>>
    
    export type RoomDeleteMutationError = unknown

    /**
 * @summary roomDelete
 */
export const useRoomDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRoomDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomList
 */
export const getRoomListUrl = (params?: RoomListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/rooms?${stringifiedParams}` : `/rooms`
}

export const roomList = async (params?: RoomListParams, options?: RequestInit): Promise<RoomList200> => {
  
  return customInstance<RoomList200>(getRoomListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getRoomListQueryKey = (params?: RoomListParams,) => {
    return [`/rooms`, ...(params ? [params]: [])] as const;
    }

    
export const getRoomListQueryOptions = <TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomList>>> = ({ signal }) => roomList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListQueryResult = NonNullable<Awaited<ReturnType<typeof roomList>>>
export type RoomListQueryError = unknown


export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params: undefined |  RoomListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomList>>,
          TError,
          Awaited<ReturnType<typeof roomList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomList>>,
          TError,
          Awaited<ReturnType<typeof roomList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomList
 */

export function useRoomList<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRoomListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomList>>> = ({ signal }) => roomList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof roomList>>>
export type RoomListSuspenseQueryError = unknown


export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params: undefined |  RoomListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary roomList
 */

export function useRoomListSuspense<TData = Awaited<ReturnType<typeof roomList>>, TError = unknown>(
 params?: RoomListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof roomList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary roomCreate
 */
export const getRoomCreateUrl = () => {


  

  return `/rooms`
}

export const roomCreate = async (roomCreateBody: RoomCreateBody, options?: RequestInit): Promise<RoomCreate201> => {
  
  return customInstance<RoomCreate201>(getRoomCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roomCreateBody,)
  }
);}




export const getRoomCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext> => {

const mutationKey = ['roomCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomCreate>>, {data: RoomCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  roomCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomCreateMutationResult = NonNullable<Awaited<ReturnType<typeof roomCreate>>>
    export type RoomCreateMutationBody = RoomCreateBody
    export type RoomCreateMutationError = unknown

    /**
 * @summary roomCreate
 */
export const useRoomCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomCreate>>, TError,{data: RoomCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomCreate>>,
        TError,
        {data: RoomCreateBody},
        TContext
      > => {

      const mutationOptions = getRoomCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary roomUpdateAdminMemo
 */
export const getRoomUpdateAdminMemoUrl = (id: string,) => {


  

  return `/rooms/${id}/admin_memo`
}

export const roomUpdateAdminMemo = async (id: string,
    roomUpdateAdminMemoBody: RoomUpdateAdminMemoBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getRoomUpdateAdminMemoUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      roomUpdateAdminMemoBody,)
  }
);}




export const getRoomUpdateAdminMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdateAdminMemo>>, TError,{id: string;data: RoomUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof roomUpdateAdminMemo>>, TError,{id: string;data: RoomUpdateAdminMemoBody}, TContext> => {

const mutationKey = ['roomUpdateAdminMemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomUpdateAdminMemo>>, {id: string;data: RoomUpdateAdminMemoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  roomUpdateAdminMemo(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RoomUpdateAdminMemoMutationResult = NonNullable<Awaited<ReturnType<typeof roomUpdateAdminMemo>>>
    export type RoomUpdateAdminMemoMutationBody = RoomUpdateAdminMemoBody
    export type RoomUpdateAdminMemoMutationError = unknown

    /**
 * @summary roomUpdateAdminMemo
 */
export const useRoomUpdateAdminMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomUpdateAdminMemo>>, TError,{id: string;data: RoomUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomUpdateAdminMemo>>,
        TError,
        {id: string;data: RoomUpdateAdminMemoBody},
        TContext
      > => {

      const mutationOptions = getRoomUpdateAdminMemoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantApplicationList
 */
export const getTenantApplicationListUrl = (params?: TenantApplicationListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenant_applications?${stringifiedParams}` : `/tenant_applications`
}

export const tenantApplicationList = async (params?: TenantApplicationListParams, options?: RequestInit): Promise<TenantApplicationList200> => {
  
  return customInstance<TenantApplicationList200>(getTenantApplicationListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantApplicationListQueryKey = (params?: TenantApplicationListParams,) => {
    return [`/tenant_applications`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantApplicationListQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(params?: TenantApplicationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationList>>> = ({ signal }) => tenantApplicationList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationListQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationList>>>
export type TenantApplicationListQueryError = unknown


export function useTenantApplicationList<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params: undefined |  TenantApplicationListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationList>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationList<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationList>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationList<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationList
 */

export function useTenantApplicationList<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantApplicationListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(params?: TenantApplicationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationList>>> = ({ signal }) => tenantApplicationList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationList>>>
export type TenantApplicationListSuspenseQueryError = unknown


export function useTenantApplicationListSuspense<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params: undefined |  TenantApplicationListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationListSuspense<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationListSuspense<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationList
 */

export function useTenantApplicationListSuspense<TData = Awaited<ReturnType<typeof tenantApplicationList>>, TError = unknown>(
 params?: TenantApplicationListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantApplicationGet
 */
export const getTenantApplicationGetUrl = (id: string,
    params?: TenantApplicationGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenant_applications/${id}?${stringifiedParams}` : `/tenant_applications/${id}`
}

export const tenantApplicationGet = async (id: string,
    params?: TenantApplicationGetParams, options?: RequestInit): Promise<TenantApplicationGet200> => {
  
  return customInstance<TenantApplicationGet200>(getTenantApplicationGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantApplicationGetQueryKey = (id?: string,
    params?: TenantApplicationGetParams,) => {
    return [`/tenant_applications/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantApplicationGetQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationGet>>> = ({ signal }) => tenantApplicationGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationGetQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationGet>>>
export type TenantApplicationGetQueryError = unknown


export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantApplicationGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationGet>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantApplicationGet>>,
          TError,
          Awaited<ReturnType<typeof tenantApplicationGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationGet
 */

export function useTenantApplicationGet<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantApplicationGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantApplicationGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantApplicationGet>>> = ({ signal }) => tenantApplicationGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantApplicationGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantApplicationGet>>>
export type TenantApplicationGetSuspenseQueryError = unknown


export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantApplicationGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantApplicationGet
 */

export function useTenantApplicationGetSuspense<TData = Awaited<ReturnType<typeof tenantApplicationGet>>, TError = unknown>(
 id: string,
    params?: TenantApplicationGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantApplicationGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantApplicationGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantGet
 */
export const getTenantGetUrl = (id: string,
    params?: TenantGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenants/${id}?${stringifiedParams}` : `/tenants/${id}`
}

export const tenantGet = async (id: string,
    params?: TenantGetParams, options?: RequestInit): Promise<TenantGet200> => {
  
  return customInstance<TenantGet200>(getTenantGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantGetQueryKey = (id?: string,
    params?: TenantGetParams,) => {
    return [`/tenants/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantGetQueryOptions = <TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantGet>>> = ({ signal }) => tenantGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantGetQueryResult = NonNullable<Awaited<ReturnType<typeof tenantGet>>>
export type TenantGetQueryError = unknown


export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantGet>>,
          TError,
          Awaited<ReturnType<typeof tenantGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantGet>>,
          TError,
          Awaited<ReturnType<typeof tenantGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantGet
 */

export function useTenantGet<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantGet>>> = ({ signal }) => tenantGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantGet>>>
export type TenantGetSuspenseQueryError = unknown


export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params: undefined |  TenantGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantGet
 */

export function useTenantGetSuspense<TData = Awaited<ReturnType<typeof tenantGet>>, TError = unknown>(
 id: string,
    params?: TenantGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantUpdate
 */
export const getTenantUpdateUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const tenantUpdate = async (id: string,
    tenantUpdateBody: TenantUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantUpdateBody,)
  }
);}




export const getTenantUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext> => {

const mutationKey = ['tenantUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantUpdate>>, {id: string;data: TenantUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantUpdate>>>
    export type TenantUpdateMutationBody = TenantUpdateBody
    export type TenantUpdateMutationError = unknown

    /**
 * @summary tenantUpdate
 */
export const useTenantUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdate>>, TError,{id: string;data: TenantUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantUpdate>>,
        TError,
        {id: string;data: TenantUpdateBody},
        TContext
      > => {

      const mutationOptions = getTenantUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantDelete
 */
export const getTenantDeleteUrl = (id: string,) => {


  

  return `/tenants/${id}`
}

export const tenantDelete = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getTenantDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['tenantDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tenantDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof tenantDelete>>>
    
    export type TenantDeleteMutationError = unknown

    /**
 * @summary tenantDelete
 */
export const useTenantDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTenantDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantList
 */
export const getTenantListUrl = (params?: TenantListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tenants?${stringifiedParams}` : `/tenants`
}

export const tenantList = async (params?: TenantListParams, options?: RequestInit): Promise<TenantList200> => {
  
  return customInstance<TenantList200>(getTenantListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTenantListQueryKey = (params?: TenantListParams,) => {
    return [`/tenants`, ...(params ? [params]: [])] as const;
    }

    
export const getTenantListQueryOptions = <TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(params?: TenantListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantList>>> = ({ signal }) => tenantList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantListQueryResult = NonNullable<Awaited<ReturnType<typeof tenantList>>>
export type TenantListQueryError = unknown


export function useTenantList<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params: undefined |  TenantListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantList>>,
          TError,
          Awaited<ReturnType<typeof tenantList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantList<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tenantList>>,
          TError,
          Awaited<ReturnType<typeof tenantList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantList<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantList
 */

export function useTenantList<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTenantListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(params?: TenantListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTenantListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tenantList>>> = ({ signal }) => tenantList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TenantListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tenantList>>>
export type TenantListSuspenseQueryError = unknown


export function useTenantListSuspense<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params: undefined |  TenantListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantListSuspense<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTenantListSuspense<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary tenantList
 */

export function useTenantListSuspense<TData = Awaited<ReturnType<typeof tenantList>>, TError = unknown>(
 params?: TenantListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tenantList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTenantListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary tenantCreate
 */
export const getTenantCreateUrl = () => {


  

  return `/tenants`
}

export const tenantCreate = async (tenantCreateBody: TenantCreateBody, options?: RequestInit): Promise<TenantCreate201> => {
  
  return customInstance<TenantCreate201>(getTenantCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantCreateBody,)
  }
);}




export const getTenantCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext> => {

const mutationKey = ['tenantCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantCreate>>, {data: TenantCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  tenantCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tenantCreate>>>
    export type TenantCreateMutationBody = TenantCreateBody
    export type TenantCreateMutationError = unknown

    /**
 * @summary tenantCreate
 */
export const useTenantCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCreate>>, TError,{data: TenantCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantCreate>>,
        TError,
        {data: TenantCreateBody},
        TContext
      > => {

      const mutationOptions = getTenantCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantCancel
 */
export const getTenantCancelUrl = (id: string,) => {


  

  return `/tenants/${id}/cancel`
}

export const tenantCancel = async (id: string,
    tenantCancelBody: TenantCancelBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantCancelUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantCancelBody,)
  }
);}




export const getTenantCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{id: string;data: TenantCancelBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{id: string;data: TenantCancelBody}, TContext> => {

const mutationKey = ['tenantCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantCancel>>, {id: string;data: TenantCancelBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantCancel(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantCancelMutationResult = NonNullable<Awaited<ReturnType<typeof tenantCancel>>>
    export type TenantCancelMutationBody = TenantCancelBody
    export type TenantCancelMutationError = unknown

    /**
 * @summary tenantCancel
 */
export const useTenantCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantCancel>>, TError,{id: string;data: TenantCancelBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantCancel>>,
        TError,
        {id: string;data: TenantCancelBody},
        TContext
      > => {

      const mutationOptions = getTenantCancelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantRevival
 */
export const getTenantRevivalUrl = (id: string,) => {


  

  return `/tenants/${id}/revival`
}

export const tenantRevival = async (id: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantRevivalUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getTenantRevivalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id: string}, TContext> => {

const mutationKey = ['tenantRevival'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantRevival>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tenantRevival(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantRevivalMutationResult = NonNullable<Awaited<ReturnType<typeof tenantRevival>>>
    
    export type TenantRevivalMutationError = unknown

    /**
 * @summary tenantRevival
 */
export const useTenantRevival = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantRevival>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantRevival>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTenantRevivalMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary tenantUpdateAdminMemo
 */
export const getTenantUpdateAdminMemoUrl = (id: string,) => {


  

  return `/tenants/${id}/admin_memo`
}

export const tenantUpdateAdminMemo = async (id: string,
    tenantUpdateAdminMemoBody: TenantUpdateAdminMemoBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTenantUpdateAdminMemoUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      tenantUpdateAdminMemoBody,)
  }
);}




export const getTenantUpdateAdminMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdateAdminMemo>>, TError,{id: string;data: TenantUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tenantUpdateAdminMemo>>, TError,{id: string;data: TenantUpdateAdminMemoBody}, TContext> => {

const mutationKey = ['tenantUpdateAdminMemo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tenantUpdateAdminMemo>>, {id: string;data: TenantUpdateAdminMemoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  tenantUpdateAdminMemo(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TenantUpdateAdminMemoMutationResult = NonNullable<Awaited<ReturnType<typeof tenantUpdateAdminMemo>>>
    export type TenantUpdateAdminMemoMutationBody = TenantUpdateAdminMemoBody
    export type TenantUpdateAdminMemoMutationError = unknown

    /**
 * @summary tenantUpdateAdminMemo
 */
export const useTenantUpdateAdminMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tenantUpdateAdminMemo>>, TError,{id: string;data: TenantUpdateAdminMemoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tenantUpdateAdminMemo>>,
        TError,
        {id: string;data: TenantUpdateAdminMemoBody},
        TContext
      > => {

      const mutationOptions = getTenantUpdateAdminMemoMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketMessageList
 */
export const getTicketMessageListUrl = (ticketId: string,
    params?: TicketMessageListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/ticket_messages/${ticketId}?${stringifiedParams}` : `/ticket_messages/${ticketId}`
}

export const ticketMessageList = async (ticketId: string,
    params?: TicketMessageListParams, options?: RequestInit): Promise<TicketMessageList200> => {
  
  return customInstance<TicketMessageList200>(getTicketMessageListUrl(ticketId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketMessageListQueryKey = (ticketId?: string,
    params?: TicketMessageListParams,) => {
    return [`/ticket_messages/${ticketId}`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketMessageListQueryOptions = <TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketMessageListQueryKey(ticketId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketMessageList>>> = ({ signal }) => ticketMessageList(ticketId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(ticketId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketMessageListQueryResult = NonNullable<Awaited<ReturnType<typeof ticketMessageList>>>
export type TicketMessageListQueryError = unknown


export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params: undefined |  TicketMessageListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketMessageList>>,
          TError,
          Awaited<ReturnType<typeof ticketMessageList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketMessageList>>,
          TError,
          Awaited<ReturnType<typeof ticketMessageList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketMessageList
 */

export function useTicketMessageList<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketMessageListQueryOptions(ticketId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketMessageListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketMessageListQueryKey(ticketId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketMessageList>>> = ({ signal }) => ticketMessageList(ticketId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketMessageListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketMessageList>>>
export type TicketMessageListSuspenseQueryError = unknown


export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params: undefined |  TicketMessageListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketMessageList
 */

export function useTicketMessageListSuspense<TData = Awaited<ReturnType<typeof ticketMessageList>>, TError = unknown>(
 ticketId: string,
    params?: TicketMessageListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketMessageList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketMessageListSuspenseQueryOptions(ticketId,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketMessageCreate
 */
export const getTicketMessageCreateUrl = (ticketId: string,) => {


  

  return `/ticket_messages/${ticketId}`
}

export const ticketMessageCreate = async (ticketId: string,
    ticketMessageCreateBody: TicketMessageCreateBody, options?: RequestInit): Promise<TicketMessageCreate201> => {
  
  return customInstance<TicketMessageCreate201>(getTicketMessageCreateUrl(ticketId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketMessageCreateBody,)
  }
);}




export const getTicketMessageCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext> => {

const mutationKey = ['ticketMessageCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketMessageCreate>>, {ticketId: string;data: TicketMessageCreateBody}> = (props) => {
          const {ticketId,data} = props ?? {};

          return  ticketMessageCreate(ticketId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketMessageCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketMessageCreate>>>
    export type TicketMessageCreateMutationBody = TicketMessageCreateBody
    export type TicketMessageCreateMutationError = unknown

    /**
 * @summary ticketMessageCreate
 */
export const useTicketMessageCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageCreate>>, TError,{ticketId: string;data: TicketMessageCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketMessageCreate>>,
        TError,
        {ticketId: string;data: TicketMessageCreateBody},
        TContext
      > => {

      const mutationOptions = getTicketMessageCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketMessageDelete
 */
export const getTicketMessageDeleteUrl = (ticketId: string,
    ticketMessageId: string,) => {


  

  return `/ticket_messages/${ticketId}/${ticketMessageId}`
}

export const ticketMessageDelete = async (ticketId: string,
    ticketMessageId: string, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketMessageDeleteUrl(ticketId,ticketMessageId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getTicketMessageDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageDelete>>, TError,{ticketId: string;ticketMessageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketMessageDelete>>, TError,{ticketId: string;ticketMessageId: string}, TContext> => {

const mutationKey = ['ticketMessageDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketMessageDelete>>, {ticketId: string;ticketMessageId: string}> = (props) => {
          const {ticketId,ticketMessageId} = props ?? {};

          return  ticketMessageDelete(ticketId,ticketMessageId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketMessageDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof ticketMessageDelete>>>
    
    export type TicketMessageDeleteMutationError = unknown

    /**
 * @summary ticketMessageDelete
 */
export const useTicketMessageDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketMessageDelete>>, TError,{ticketId: string;ticketMessageId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketMessageDelete>>,
        TError,
        {ticketId: string;ticketMessageId: string},
        TContext
      > => {

      const mutationOptions = getTicketMessageDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketGet
 */
export const getTicketGetUrl = (id: string,
    params?: TicketGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tickets/${id}?${stringifiedParams}` : `/tickets/${id}`
}

export const ticketGet = async (id: string,
    params?: TicketGetParams, options?: RequestInit): Promise<TicketGet200> => {
  
  return customInstance<TicketGet200>(getTicketGetUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketGetQueryKey = (id?: string,
    params?: TicketGetParams,) => {
    return [`/tickets/${id}`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketGetQueryOptions = <TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketGet>>> = ({ signal }) => ticketGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketGetQueryResult = NonNullable<Awaited<ReturnType<typeof ticketGet>>>
export type TicketGetQueryError = unknown


export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params: undefined |  TicketGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketGet>>,
          TError,
          Awaited<ReturnType<typeof ticketGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketGet>>,
          TError,
          Awaited<ReturnType<typeof ticketGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketGet
 */

export function useTicketGet<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketGetQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketGetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketGet>>> = ({ signal }) => ticketGet(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketGet>>>
export type TicketGetSuspenseQueryError = unknown


export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params: undefined |  TicketGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketGet
 */

export function useTicketGetSuspense<TData = Awaited<ReturnType<typeof ticketGet>>, TError = unknown>(
 id: string,
    params?: TicketGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketGetSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketUpdate
 */
export const getTicketUpdateUrl = (id: string,) => {


  

  return `/tickets/${id}`
}

export const ticketUpdate = async (id: string,
    ticketUpdateBody: TicketUpdateBody, options?: RequestInit): Promise<TicketUpdate200> => {
  
  return customInstance<TicketUpdate200>(getTicketUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdateBody,)
  }
);}




export const getTicketUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext> => {

const mutationKey = ['ticketUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketUpdate>>, {id: string;data: TicketUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketUpdate>>>
    export type TicketUpdateMutationBody = TicketUpdateBody
    export type TicketUpdateMutationError = unknown

    /**
 * @summary ticketUpdate
 */
export const useTicketUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdate>>, TError,{id: string;data: TicketUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketUpdate>>,
        TError,
        {id: string;data: TicketUpdateBody},
        TContext
      > => {

      const mutationOptions = getTicketUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketDelete
 */
export const getTicketDeleteUrl = (id: string,) => {


  

  return `/tickets/${id}`
}

export const ticketDelete = async (id: string, options?: RequestInit): Promise<TicketDelete200> => {
  
  return customInstance<TicketDelete200>(getTicketDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getTicketDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['ticketDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ticketDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof ticketDelete>>>
    
    export type TicketDeleteMutationError = unknown

    /**
 * @summary ticketDelete
 */
export const useTicketDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTicketDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketList
 */
export const getTicketListUrl = (params?: TicketListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/tickets?${stringifiedParams}` : `/tickets`
}

export const ticketList = async (params?: TicketListParams, options?: RequestInit): Promise<TicketList200> => {
  
  return customInstance<TicketList200>(getTicketListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}



export const getTicketListQueryKey = (params?: TicketListParams,) => {
    return [`/tickets`, ...(params ? [params]: [])] as const;
    }

    
export const getTicketListQueryOptions = <TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketList>>> = ({ signal }) => ticketList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketListQueryResult = NonNullable<Awaited<ReturnType<typeof ticketList>>>
export type TicketListQueryError = unknown


export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params: undefined |  TicketListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketList>>,
          TError,
          Awaited<ReturnType<typeof ticketList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ticketList>>,
          TError,
          Awaited<ReturnType<typeof ticketList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketList
 */

export function useTicketList<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTicketListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTicketListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ticketList>>> = ({ signal }) => ticketList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TicketListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ticketList>>>
export type TicketListSuspenseQueryError = unknown


export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params: undefined |  TicketListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ticketList
 */

export function useTicketListSuspense<TData = Awaited<ReturnType<typeof ticketList>>, TError = unknown>(
 params?: TicketListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ticketList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTicketListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary ticketCreate
 */
export const getTicketCreateUrl = () => {


  

  return `/tickets`
}

export const ticketCreate = async (ticketCreateBody: TicketCreateBody, options?: RequestInit): Promise<TicketCreate201> => {
  
  return customInstance<TicketCreate201>(getTicketCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketCreateBody,)
  }
);}




export const getTicketCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext> => {

const mutationKey = ['ticketCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketCreate>>, {data: TicketCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  ticketCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketCreate>>>
    export type TicketCreateMutationBody = TicketCreateBody
    export type TicketCreateMutationError = unknown

    /**
 * @summary ticketCreate
 */
export const useTicketCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCreate>>, TError,{data: TicketCreateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketCreate>>,
        TError,
        {data: TicketCreateBody},
        TContext
      > => {

      const mutationOptions = getTicketCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketAddProgress
 */
export const getTicketAddProgressUrl = (id: string,) => {


  

  return `/tickets/${id}/progress`
}

export const ticketAddProgress = async (id: string,
    ticketAddProgressBody: TicketAddProgressBody, options?: RequestInit): Promise<TicketAddProgress201> => {
  
  return customInstance<TicketAddProgress201>(getTicketAddProgressUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketAddProgressBody,)
  }
);}




export const getTicketAddProgressMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketAddProgress>>, TError,{id: string;data: TicketAddProgressBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketAddProgress>>, TError,{id: string;data: TicketAddProgressBody}, TContext> => {

const mutationKey = ['ticketAddProgress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketAddProgress>>, {id: string;data: TicketAddProgressBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketAddProgress(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketAddProgressMutationResult = NonNullable<Awaited<ReturnType<typeof ticketAddProgress>>>
    export type TicketAddProgressMutationBody = TicketAddProgressBody
    export type TicketAddProgressMutationError = unknown

    /**
 * @summary ticketAddProgress
 */
export const useTicketAddProgress = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketAddProgress>>, TError,{id: string;data: TicketAddProgressBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketAddProgress>>,
        TError,
        {id: string;data: TicketAddProgressBody},
        TContext
      > => {

      const mutationOptions = getTicketAddProgressMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketUpdateOcComment
 */
export const getTicketUpdateOcCommentUrl = (id: string,) => {


  

  return `/tickets/${id}/oc-comment`
}

export const ticketUpdateOcComment = async (id: string,
    ticketUpdateOcCommentBody: TicketUpdateOcCommentBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketUpdateOcCommentUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketUpdateOcCommentBody,)
  }
);}




export const getTicketUpdateOcCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateOcComment>>, TError,{id: string;data: TicketUpdateOcCommentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateOcComment>>, TError,{id: string;data: TicketUpdateOcCommentBody}, TContext> => {

const mutationKey = ['ticketUpdateOcComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketUpdateOcComment>>, {id: string;data: TicketUpdateOcCommentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketUpdateOcComment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketUpdateOcCommentMutationResult = NonNullable<Awaited<ReturnType<typeof ticketUpdateOcComment>>>
    export type TicketUpdateOcCommentMutationBody = TicketUpdateOcCommentBody
    export type TicketUpdateOcCommentMutationError = unknown

    /**
 * @summary ticketUpdateOcComment
 */
export const useTicketUpdateOcComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketUpdateOcComment>>, TError,{id: string;data: TicketUpdateOcCommentBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketUpdateOcComment>>,
        TError,
        {id: string;data: TicketUpdateOcCommentBody},
        TContext
      > => {

      const mutationOptions = getTicketUpdateOcCommentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketReadMessage
 */
export const getTicketReadMessageUrl = (id: string,) => {


  

  return `/tickets/${id}/read-message`
}

export const ticketReadMessage = async (id: string,
    ticketReadMessageBody: TicketReadMessageBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketReadMessageUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketReadMessageBody,)
  }
);}




export const getTicketReadMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketReadMessage>>, TError,{id: string;data: TicketReadMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketReadMessage>>, TError,{id: string;data: TicketReadMessageBody}, TContext> => {

const mutationKey = ['ticketReadMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketReadMessage>>, {id: string;data: TicketReadMessageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  ticketReadMessage(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketReadMessageMutationResult = NonNullable<Awaited<ReturnType<typeof ticketReadMessage>>>
    export type TicketReadMessageMutationBody = TicketReadMessageBody
    export type TicketReadMessageMutationError = unknown

    /**
 * @summary ticketReadMessage
 */
export const useTicketReadMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketReadMessage>>, TError,{id: string;data: TicketReadMessageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketReadMessage>>,
        TError,
        {id: string;data: TicketReadMessageBody},
        TContext
      > => {

      const mutationOptions = getTicketReadMessageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketCommentUpdate
 */
export const getTicketCommentUpdateUrl = (id: number,
    ticketCommentId: number,) => {


  

  return `/ticket_comments/${id}/comments/${ticketCommentId}`
}

export const ticketCommentUpdate = async (id: number,
    ticketCommentId: number,
    ticketCommentUpdateBody: TicketCommentUpdateBody, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketCommentUpdateUrl(id,ticketCommentId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      ticketCommentUpdateBody,)
  }
);}




export const getTicketCommentUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCommentUpdate>>, TError,{id: number;ticketCommentId: number;data: TicketCommentUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketCommentUpdate>>, TError,{id: number;ticketCommentId: number;data: TicketCommentUpdateBody}, TContext> => {

const mutationKey = ['ticketCommentUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketCommentUpdate>>, {id: number;ticketCommentId: number;data: TicketCommentUpdateBody}> = (props) => {
          const {id,ticketCommentId,data} = props ?? {};

          return  ticketCommentUpdate(id,ticketCommentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketCommentUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof ticketCommentUpdate>>>
    export type TicketCommentUpdateMutationBody = TicketCommentUpdateBody
    export type TicketCommentUpdateMutationError = unknown

    /**
 * @summary ticketCommentUpdate
 */
export const useTicketCommentUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCommentUpdate>>, TError,{id: number;ticketCommentId: number;data: TicketCommentUpdateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketCommentUpdate>>,
        TError,
        {id: number;ticketCommentId: number;data: TicketCommentUpdateBody},
        TContext
      > => {

      const mutationOptions = getTicketCommentUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * @summary ticketCommentDelete
 */
export const getTicketCommentDeleteUrl = (id: number,
    ticketCommentId: number,) => {


  

  return `/ticket_comments/${id}/comments/${ticketCommentId}`
}

export const ticketCommentDelete = async (id: number,
    ticketCommentId: number, options?: RequestInit): Promise<null> => {
  
  return customInstance<null>(getTicketCommentDeleteUrl(id,ticketCommentId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getTicketCommentDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCommentDelete>>, TError,{id: number;ticketCommentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ticketCommentDelete>>, TError,{id: number;ticketCommentId: number}, TContext> => {

const mutationKey = ['ticketCommentDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ticketCommentDelete>>, {id: number;ticketCommentId: number}> = (props) => {
          const {id,ticketCommentId} = props ?? {};

          return  ticketCommentDelete(id,ticketCommentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TicketCommentDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof ticketCommentDelete>>>
    
    export type TicketCommentDeleteMutationError = unknown

    /**
 * @summary ticketCommentDelete
 */
export const useTicketCommentDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ticketCommentDelete>>, TError,{id: number;ticketCommentId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ticketCommentDelete>>,
        TError,
        {id: number;ticketCommentId: number},
        TContext
      > => {

      const mutationOptions = getTicketCommentDeleteMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
